import * as React from 'react';
import { cn } from '../../utils/cn';

type SpacingValue = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16 | 20 | 24 | 32;

export interface SpacerProps {
  size?: SpacingValue;
  x?: SpacingValue;
  y?: SpacingValue;
  grow?: boolean;
  shrink?: boolean;
  basis?: 'auto' | '0' | 'full' | string;
  className?: string;
}

const getSpacingValue = (value: SpacingValue): string => {
  return String(value);
};

export const Spacer = React.forwardRef<HTMLDivElement, SpacerProps>(
  ({ size, x, y, grow = false, shrink = false, basis, className }, ref) => {
    // If grow is true and no size specified, create a flexible spacer
    if (grow && !size && !x && !y) {
      return (
        <div
          ref={ref}
          className={cn(
            'flex-grow',
            shrink && 'flex-shrink',
            basis && `flex-basis-${basis}`,
            className
          )}
          aria-hidden="true"
        />
      );
    }

    // Otherwise create a fixed spacer
    const width =
      x !== undefined
        ? `w-${getSpacingValue(x)}`
        : size !== undefined
          ? `w-${getSpacingValue(size)}`
          : undefined;
    const height =
      y !== undefined
        ? `h-${getSpacingValue(y)}`
        : size !== undefined
          ? `h-${getSpacingValue(size)}`
          : undefined;

    return (
      <div ref={ref} className={cn(width, height, 'flex-shrink-0', className)} aria-hidden="true" />
    );
  }
);

Spacer.displayName = 'Spacer';
